module.exports = __webpack_public_path__ + "img/MES.8b87dc16.png";